export default __webpack_public_path__ + "static/media/transcendGrowthImage1.0cce4b88.jpg";